const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const offices = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case "CLEAR_OFFICE_CACHE":
      return { ...state, data: [] };

    case "SET_CAMPAIGN_OFFICES":
      return { ...state, data: action.data };

    case "UPDATE_OFFICE":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case "REMOVE_OFFICE":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case "INSERT_OFFICE":
      return { ...state, data: [...state.data, action.data] };

    case "SET_CAMPAIGN_OFFICES_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_CAMPAIGN_OFFICES_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default offices;
